angular.module('impactx.help').service('HelpService', [
    '$route',
    '$compile',
    '$rootScope',
    'dataGen',
    HelpService
]);

function HelpService($route, $compile, $rootScope, dataGen) {
    var self = this;

    self.close = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        angular.element("ix-help").remove();
    };

    self.getCurrentRoute = function () {
        return impactX.routeForHelpService($route.current.originalPath)
    };

    self.open = function () {
        angular.element("ix-help").remove();
        var body = angular.element('body');
        var helpWindow = $compile('<ix-help></ix-help>')($rootScope.$new());
        body.append(helpWindow);
    };

    self.searchDocument = function (userQuery) {
        var params = {
            userQuery: userQuery
        };
        return dataGen.getData({}, params, "/help/search");
    };

    self.getDocument = function () {
        var params = {
            route: self.getCurrentRoute()
        };
        return dataGen.getData({}, params, "/help/route");
    };

    return {
        open: self.open,
        close: self.close,
        getCurrentRoute: self.getCurrentRoute,
        getDocument: self.getDocument,
        searchDocument: self.searchDocument
    };
}